import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-next.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2a6e29d4")

_pushScopeId("data-v-2a6e29d4")
const _hoisted_1 = {
  class: "border-gray-lp-1300 shadow-outer w-full rounded-xl border bg-white",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = { class: "flex justify-between border-b p-4" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-row items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "p-field-checkbox relative -mt-1"
}
const _hoisted_7 = { class: "flex flex-row items-center gap-1" }
const _hoisted_8 = { class: "text-[14px] font-semibold text-gray-lp-300" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: `font-bold text-black mx-1 text-2xl` }, " · ", -1)
const _hoisted_10 = { class: "text-[16px] text-gray-lp-300" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: `font-bold text-black mx-1 text-2xl` }, " · ", -1)
const _hoisted_12 = { class: `text-[16px] font-bold text-black-lp-300` }
const _hoisted_13 = { class: "flex gap-2" }
const _hoisted_14 = { class: "text-[14px] font-semibold text-gray-lp-600" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 max-w-none",
  alt: "chevron-right"
}, null, -1)
const _hoisted_16 = { class: "py-3 px-4" }
const _hoisted_17 = { class: "border border-gray-lp-200 rounded-lg overflow-y-auto popup-dimension flex-grow relative" }
const _hoisted_18 = { class: "table-fixed w-full" }
const _hoisted_19 = { class: "sticky top-0 z-10 bg-gray-lp-100 border-b border-gray-lp-200 shadow-sm" }
const _hoisted_20 = { class: "w-6 text-left font-bold text-black-lp-300 p-3 whitespace-nowrap" }
const _hoisted_21 = { class: "w-88 text-left font-bold text-black-lp-300 p-3 whitespace-nowrap" }
const _hoisted_22 = { class: "w-20 text-left font-bold text-black-lp-300 p-3 whitespace-nowrap" }
const _hoisted_23 = { class: "w-20 text-left font-bold text-black-lp-300 p-3 pr-12 whitespace-nowrap" }
const _hoisted_24 = { class: "w-20 text-left font-bold text-black-lp-300 p-3 pr-12 whitespace-nowrap" }
const _hoisted_25 = { class: "w-20 text-right font-bold text-black-lp-300 p-3 whitespace-nowrap" }
const _hoisted_26 = { class: "text-left px-3 py-3 text-16px whitespace-nowrap" }
const _hoisted_27 = { class: "text-left px-3 py-3 text-16px" }
const _hoisted_28 = { class: "flex items-center gap-2" }
const _hoisted_29 = { class: `text-[16px]` }
const _hoisted_30 = { class: "text-left px-3 py-3 text-16px " }
const _hoisted_31 = { class: "flex flex-row gap-1" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "text-left px-3 py-3 text-16px" }
const _hoisted_34 = { class: "flex flex-row gap-1" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "text-right px-3 py-3 text-16px" }
const _hoisted_37 = { class: "flex flex-row justify-between items-center pt-3" }
const _hoisted_38 = { class: "flex gap-2 items-center" }
const _hoisted_39 = { class: "text-right pl-6" }
const _hoisted_40 = { class: "text-[14px] font-semibold" }
const _hoisted_41 = { class: "text-[16px] font-bold text-red-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalDetailProductKulioner = _resolveComponent("ModalDetailProductKulioner")!
  const _component_ModalSuccessProcessOrder = _resolveComponent("ModalSuccessProcessOrder")!
  const _component_ModalProcessKulioner = _resolveComponent("ModalProcessKulioner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_ctx.isCheckable)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode(_component_Checkbox, {
                      id: "checkbox-kulioner-card",
                      binary: true,
                      modelValue: _ctx.isChecked,
                      onChange: _ctx.setValueCheckbox
                    }, null, 8, ["modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.data.orderId), 1),
                _hoisted_9,
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.data.recipientName), 1),
                _hoisted_11,
                _createVNode("p", _hoisted_12, _toDisplayString(_ctx.data.totalMerchant) + " " + _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalMerchant")), 1),
                _createVNode("img", {
                  src: _ctx.mapProductLogo(_ctx.data.productType),
                  class: "w-20 max-w-none justify-self-end",
                  alt: "product"
                }, null, 8, ["src"]),
                _createVNode("div", {
                  class: "flex flex-row px-2 py-0.5 gap-1 rounded-2xl",
                  style: { backgroundColor: _ctx.mapCycleTime(_ctx.data.cycleAt).background }
                }, [
                  (_ctx.data.cycleAt)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "clock-v4",
                        style: [{"width":"18px","height":"18px"}, { color: _ctx.mapCycleTime(_ctx.data.cycleAt).color }]
                      }, null, 8, ["style"]))
                    : _createCommentVNode("", true),
                  _createVNode("p", {
                    class: "font-medium text-sm",
                    style: { color: _ctx.mapCycleTime(_ctx.data.cycleAt).color }
                  }, _toDisplayString(_ctx.mapCycleTime(_ctx.data.cycleAt).label), 5)
                ], 4)
              ])
            ])
          ])
        ]),
        _createVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickDetail && _ctx.onClickDetail(...args))),
          class: "flex gap-2 cursor-pointer"
        }, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", {
                class: 
                `rounded-full px-2 py-0 ${_ctx.statusInfo.color} text-[16px] font-medium ${_ctx.statusInfo.textColor}`
              
              }, [
                _createVNode("span", null, _toDisplayString(_ctx.statusInfo.label), 1)
              ], 2),
              _createVNode("p", _hoisted_14, _toDisplayString(_ctx.formatDate), 1)
            ])
          ]),
          _hoisted_15
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("table", _hoisted_18, [
            _createVNode("thead", _hoisted_19, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("kulioner.merchant.table.no")), 1),
                _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("kulioner.merchant.table.merchant")), 1),
                _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("kulioner.merchant.table.totalProduct")), 1),
                _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("kulioner.merchant.table.totalItem")), 1),
                _createVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("kulioner.merchant.table.status")), 1),
                _createVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("kulioner.merchant.table.subtotal")), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slicedMerchant, (merchant, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: "border-t border-gray-lp-200"
                }, [
                  _createVNode("td", _hoisted_26, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("img", {
                        src: `${merchant.thumbnail}`,
                        class: "w-10 h-10 object-cover mr-1 rounded-md",
                        alt: "product"
                      }, null, 8, ["src"]),
                      _createVNode("p", _hoisted_29, _toDisplayString(merchant.name), 1)
                    ])
                  ]),
                  _createVNode("td", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", {
                        class: _ctx.showActualTotalProduct(merchant) ? 'strikethrough' : ''
                      }, _toDisplayString(merchant.totalProduct), 3),
                      (_ctx.showActualTotalProduct(merchant))
                        ? (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(merchant.actualProduct), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("td", _hoisted_33, [
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", {
                        class: _ctx.showActualTotalQuantity(merchant) ? 'strikethrough' : ''
                      }, _toDisplayString(merchant.totalQuantity), 3),
                      (_ctx.showActualTotalQuantity(merchant))
                        ? (_openBlock(), _createBlock("div", _hoisted_35, _toDisplayString(merchant.actualQuantity), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("td", {
                    class: ["text-left px-3 py-3 text-16px", `${_ctx.mapStatusProduct(merchant).textColor}`]
                  }, _toDisplayString(_ctx.mapStatusProduct(merchant).label), 3),
                  _createVNode("td", _hoisted_36, _toDisplayString(_ctx.formatPrice(merchant.totalPrice)), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_37, [
          _createVNode("div", null, [
            (_ctx.showButtonShowMoreMerchant)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  title: _ctx.$t('kulioner.merchant.viewMoreMerchant', { count: _ctx.data.totalMerchant - 3 }),
                  textAlign: "text-left",
                  color: "white",
                  textColor: "red-lp-100",
                  customClass: "underline",
                  iconGroupHoverColor: "gray-lp-300",
                  textSize: "14",
                  compact: "",
                  fontWeight: "semibold",
                  disabled: _ctx.isLoadingDownloadOrder,
                  onClick: _ctx.onClickShowMoreMerchant
                }, null, 8, ["title", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showButtonShowLessMerchant)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 1,
                  title: _ctx.$t('kulioner.merchant.viewLess'),
                  textAlign: "text-left",
                  color: "white",
                  textColor: "red-lp-100",
                  customClass: "underline",
                  iconGroupHoverColor: "gray-lp-300",
                  textSize: "14",
                  compact: "",
                  fontWeight: "semibold",
                  disabled: _ctx.isLoadingDownloadOrder,
                  onClick: _ctx.onClickShowLessMerchant
                }, null, 8, ["title", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_38, [
            (_ctx.showButtonPrintResi)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  title: _ctx.$t('Print PDF'),
                  color: "white",
                  textColor: "gray-lp-300",
                  textSize: "14",
                  customClass: "underline",
                  iconLeft: "printer-black",
                  sizeIcon: "24px",
                  small: "",
                  fontWeight: "semibold",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.onPrintReceipt(_ctx.data.orderSttNo))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_LpButton, {
              id: "download-order-kulioner-button",
              title: _ctx.$t('Download data'),
              color: "white",
              textColor: "gray-lp-300",
              customClass: "underline",
              iconLeft: "download-new",
              iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
              iconGroupHoverColor: "gray-lp-300",
              sizeIcon: "18px",
              iconV2: "",
              textSize: "14",
              small: "",
              fontWeight: "semibold",
              disabled: _ctx.isLoadingDownloadOrder,
              onClick: _ctx.onDownloadOrder
            }, null, 8, ["title", "iconColor", "disabled", "onClick"]),
            (_ctx.data.status === 'ORDWTC')
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 1,
                  title: _ctx.$t('kulioner.merchant.acceptOrder'),
                  textColor: "white",
                  fontWeight: "semibold",
                  onClick: _ctx.onAcceptOrder
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.data.status === 'ORDPRC')
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 2,
                  title: _ctx.$t('kulioner.merchant.processShipment'),
                  textColor: "white",
                  fontWeight: "semibold",
                  disabled: _ctx.isLoadingProcessOrder || !_ctx.isEligibleProcessOrderByCustomer,
                  onClick: _ctx.onProcessOrder
                }, null, 8, ["title", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.showButtonTracking)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 3,
                  outline: "",
                  color: "red-lp-100",
                  title: _ctx.$t('kulioner.merchant.trackShipment'),
                  textColor: "red-lp-100",
                  fontWeight: "semibold",
                  onClick: _ctx.onTrackingOrder
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_39, [
              _createVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalTransaction")), 1),
              _createVNode("p", _hoisted_41, _toDisplayString(_ctx.formatPrice(_ctx.data.totalPrice)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalDetailProductKulioner, {
      showPopupDetailProduct: _ctx.isShowModalPopupDetail,
      onClosePopup: _ctx.onCloseModalPopupDetailProduct,
      data: _ctx.data.product
    }, null, 8, ["showPopupDetailProduct", "onClosePopup", "data"]),
    _createVNode(_component_ModalSuccessProcessOrder, {
      key: _ctx.successProcessResponse.sttId,
      modelValue: _ctx.isShowSuccessProcessModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowSuccessProcessModal = $event)),
      messageData: _ctx.successProcessResponse,
      productType: _ctx.sttProductType,
      onClose: _ctx.closeModalSuccess,
      onOnPrintThermalPdf: _ctx.onPrintReceipt
    }, null, 8, ["modelValue", "messageData", "productType", "onClose", "onOnPrintThermalPdf"]),
    _createVNode(_component_ModalProcessKulioner, {
      id: "modal-confirm-accept-order",
      modelValue: _ctx.isShowModalProcessKulioner,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModalProcessKulioner = $event)),
      data: _ctx.dataKulioner,
      onSuccess: _ctx.onSuccess,
      onFailed: _ctx.onFailed,
      onRefetch: _ctx.closeModalSuccess
    }, null, 8, ["modelValue", "data", "onSuccess", "onFailed", "onRefetch"])
  ], 64))
})